export enum UserKycStatusEnum {
  NotVerified = 'Not Verified',
  Pending = 'Pending',
  Verified = 'Verified',
}